module.exports = __webpack_public_path__ + "images/pencilf7c77f8a1c29bcd055fd3b298d086091.svg";